<template>
  <div class="visualizer-elist">
    <div class="visua-right-title">您的事件</div>
    <ul class="visua-namelist">
      <template v-for="event in eventList">
        <template v-if="event.eventJson">
          <c-tooltip
            :key="event.eventId + '_' + event.eventName"
            :ref="event.eventId + '_' + event.eventName"
            placement="left-top"
            theme="light"
            :autoHide="false"
          >
            <template slot="tooltip">
              <img :src="event.screenshot" :style="overviewStyle"/>
            </template>
            <li 
              :class="{'visua-removed': event.eventJson.status === 'del', 'ename-item': true}"
              @mouseenter="onHover(event.screenshot, event.eventId + '_' + event.eventName)"
              @mouseleave="onHide(event.eventId + '_' + event.eventName)">
              <div class="ename">{{ event.eventName }}</div>
              <i class="i-del cicon-delete-little1" @click="onDel(event)"></i>
            </li>
          </c-tooltip>
        </template>
        <template v-else>
          <c-tooltip 
            :key="event.id + '_' + event.event_name" 
            :ref="event.id + '_' + event.event_name" 
            placement="left-top" theme="light">
            <template slot="tooltip">
              <img :src="event.screenshot" :style="overviewStyle"/>
            </template>
            <li 
              class="visua-new ename-item"
              @mouseenter="onHover(event.screenshot, event.id + '_' + event.event_name)"
              @mouseleave="onHide(event.id + '_' + event.event_name)">
              <span class="visua-badge">new</span>
              <div class="ename">{{ event.event_name }}</div>
              <i class="i-del cicon-delete-little1" @click="onDel(event)"></i>
            </li>
          </c-tooltip>
        </template>
      </template>
    </ul>
    <div class="visua-list-foot">
      <c-button size="normal" type="primary" @click="onApply">生效</c-button>
      <c-button size="normal" style="margin-left: 20px" @click="onCancel">取消</c-button>
    </div>
  </div>
</template>
<script>
import { actions } from "../../store/constants";
import { mapState } from "vuex";
import { util } from "../../utils";
export default {
  name: "visuaEventList",
  data() {
    return {
      overviewStyle: {
        width: 'auto'
      }
    };
  },
  computed: {
    ...mapState({
      eventList(state) {
        return state.bizVisualizer.eventList;
      }
    })
  },
  mounted() {
    this.getEventList();
  },
  methods: {
    getEventList() {
      this.$store.dispatch(actions.visualizer.queryEvents, {
        appId: this.appId,
        platform: 2
      });
    },
    onDel(event) {
      this.$store.dispatch(actions.visualizer.delEvent, event);
    },
    onApply() {
      const eventData = {
        event_json: [],
        app_id: this.appId,
        platform: 2
      };
      const socketData = {
        type: "event_binding_request",
        payload: {
          events: []
        }
      };
      const devent = [];
      this.eventList.forEach(item => {
        const event = item.eventJson
          ? item.eventJson
          : util.clone(item);
        if (event.status === "add") {
          delete event.status;
          delete event.screenshot
          eventData.event_json.push(event);
          socketData.payload.events.push(event);
        } else if (event.status === "del") {
          devent.push(item.screenId);
        } else {
          socketData.payload.events.push(event);
        }
      })
      this.$emit("bindEvents", JSON.stringify(socketData));
      eventData.event_json = JSON.stringify(eventData.event_json);
      this.$store.dispatch(actions.visualizer.applyEvents, eventData)
        .finally(() => {
          this.getEventList()
        })
      if (devent.length) {
        this.$store.dispatch(actions.visualizer.removeEvents, {
          appId: this.appId,
          platform: 2,
          events: devent.join(",")
        });
      }
    },
    onCancel() {
      this.$store.dispatch(actions.visualizer.cancel)
    },
    onHover(src, ref) {
      const img = new Image()
      img.onload = () => {
        this.overviewStyle.width = img.width / 2 + 'px'
        const tooltip = this.$refs[ref][0]
        tooltip.show()
      }
      img.src = src
    },
    onHide(ref) {
      const tooltip = this.$refs[ref][0]
      tooltip.hide()
    }
  }
};
</script>
<style lang="sass">
@import './styles/eventList'
</style>
